export default "__VITE_ASSET__Cs7rfsOr__"